import { render } from "./TransferComponent.vue?vue&type=template&id=4067e27e&scoped=true"
import script from "./TransferComponent.vue?vue&type=script&lang=js"
export * from "./TransferComponent.vue?vue&type=script&lang=js"

import "./TransferComponent.vue?vue&type=style&index=0&id=4067e27e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4067e27e"]])

export default __exports__